import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import initApp from './init-app'
import session from './session'
import registration from './registration'
import google from './google'
import facebook from './facebook'
import twitter from './twitter'
import updatePassword from './update-password'
import profile from './profile'
import authState from './auth'

const rootReducer = combineReducers({
  app: initApp,
  auth: authState,
  session,
  registration,
  google,
  facebook,
  twitter,
  profile,
  updatePassword,
  routing: routerReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js